import React from 'react';
import PropTypes from "prop-types";
import { connect } from '../../../../../../redux/connect';
import {
  getCurrentViewType,
} from '../../../../../../redux/selectors';
import { issueAttributesType } from "../../../../../../constants/proptype-validation";
import DescriptionInlineEdit from "./components/DescriptionInlineEdit";
import SuggestedAnswerInlineEdit from "./components/SuggestedAnswerInlineEdit";
import classNames from "classnames";
import { viewTypes } from "../../../../../../constants/view-types";

export const PureIssuePreviewDetailsTabQuestionSection = ({ issue, viewType }) => {
  const divClassNames = classNames('IssuePreviewDetailsTabQuestionSection', {
    'IssuePreviewDetailsTabQuestionSection__narrow': viewType === viewTypes.DOCUMENT,
    'IssuePreviewDetailsTabQuestionSection__wide': viewType === viewTypes.PROJECT,
  });
  return <form className={divClassNames}>
    <div className="IssuePreviewDetailsTabQuestionSection__fieldWrapper">
      <DescriptionInlineEdit
        issue={issue}
        className="IssuePreviewDetailsTabQuestionSection__field"
      />
    </div>
    <div className="IssuePreviewDetailsTabQuestionSection__fieldWrapper">
      {/* Suggested answer */}
      <SuggestedAnswerInlineEdit
        issue={issue}
      />
    </div>

  </form>;
};

PureIssuePreviewDetailsTabQuestionSection.displayName = 'IssuePreviewDetailsTabQuestionSection';

PureIssuePreviewDetailsTabQuestionSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  viewType: getCurrentViewType(state),
});

export default connect(mapStateToProps)(PureIssuePreviewDetailsTabQuestionSection);
